import {
    personalInfoUrl,
    updateShipToUrl ,
    feedbackUrl,
    orderReportUrl,
    scHostInforUrl,
    applyBackupUrl
} from 'Utils/urlUtil'
import { T } from 'Actions/translate';

export default (errorMsg, url, method, params, data) => {
    switch(errorMsg) {
        // case 'bad_request':
        // case 'sql_syntax_error':
        // case 'internal_server_error':
        // case 'export_error':
        //     if(url === personalInfoUrl) return '未获取到用户详情，服务器出现异常';
        //     if(url === updateShipToUrl ) return '设置失败，服务器出现异常';
        //     if(url === feedbackUrl) return '提交反馈失败，服务器出现异常';
        //     if(url === orderReportUrl) return '订单报表发送失败，服务器出现异常';
        //     if(url === scHostInforUrl) return '未获取到配送员信息，服务器出现异常';
        //     break;
        case 'no_content':
            if(url === orderReportUrl) return T('notification_no_order_report_is_available');
            break;
        case 'unknown_sku':
            if(url === applyBackupUrl) return T('notification_no_sku');
            break;
        default:
            if(url === personalInfoUrl) return T('notification_user_details_were_not_obtained');
            if(url === updateShipToUrl ) return T('notification_setup_failed');
            if(url === feedbackUrl) return T('notification_setup_failed');
            if(url === orderReportUrl) return T('notification_order_report_delivery_failed');
            if(url === scHostInforUrl) return T('notification_no_deliveryman_information_was_obtained');
            break;
    }
}
